export default {
  notification: {
    default: 'Notifications',
    empty: 'Aucune notification',
    show: {
      show: 'Voir les notifications'
    }
  }
}
